import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from '@domain-group/fe-blueprint-ui/form';
import * as styles from './selector.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Selector = _ref => {
  var name = _ref.name,
    options = _ref.options,
    selectedValue = _ref.selectedValue,
    onSelect = _ref.onSelect,
    type = _ref.type,
    className = _ref.className;
  var renderOptions = () => options.map((option, index) => {
    var optionButton = ___EmotionJSX("span", {
      css: styles.subheading({
        radio: type === 'radio',
        indented: type === 'list'
      })
    }, option.label);
    if (option.value) {
      var isSelected = option.value === selectedValue;
      if (type === 'radio') {
        optionButton = ___EmotionJSX(Radio, {
          checked: isSelected,
          name: name,
          css: styles.radio(option.indented),
          onChange: () => {
            onSelect(option.value);
          },
          labelContent: option.label || option.component
        });
      } else if (option.component) {
        optionButton = ___EmotionJSX("div", {
          css: styles.button({
            selected: isSelected,
            indented: option.indented
          })
        }, option.component);
      } else {
        optionButton = ___EmotionJSX("button", {
          css: styles.button({
            selected: isSelected,
            indented: option.indented
          }),
          onClick: () => {
            onSelect(option.value);
          },
          type: "button"
        }, option.label);
      }
    }
    return ___EmotionJSX("li", {
      css: styles.item,
      key: option.value || "NOVALUE-".concat(index)
    }, optionButton);
  });
  return ___EmotionJSX("ul", {
    css: styles.container,
    className: className
  }, renderOptions());
};
Selector.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.node,
    component: PropTypes.node,
    indented: PropTypes.bool
  })),
  selectedValue: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  type: PropTypes.oneOf(['radio', 'list']),
  className: PropTypes.string
};
Selector.defaultProps = {
  name: undefined,
  options: [],
  type: 'list',
  onSelect: () => {},
  className: undefined
};
export default Selector;